<template>
    <div>
        <v-progress-linear
        :active="cargando"
        :indeterminate="cargando"
        absolute
        top
        color="deep-purple accent-4"
        ></v-progress-linear>
        <v-snackbar
        v-model="mostrarMensaje"
        :timeout="3000"
        :color="mensaje.color"
        top
        >
            {{ mensaje.texto }}
        </v-snackbar>
        <h1>Registrar usuario</h1>
        <form-usuario :usuario="usuario" @registrado="onRegistrado"/>
    </div>
</template>
<script>
import ApiService from '../../Servicios/ApiService'
import FormUsuario from './FormUsuario.vue'

export default {
    name: "NuevoUsuario",
    components: { FormUsuario },

    data: () => ({
        cargando: false,
        usuario: { usuario: '', nombre: '', telefono: '', email: '', rol: '', clave: '' },
        mostrarMensaje: false,
        mensaje: { texto: '', color: '' }
    }),

    methods: {
        async onRegistrado (usuario) {
            this.cargando = true
            try {
                await ApiService.post('api/panel/usuarios', usuario)
                this.mostrarMensaje = true
                this.mensaje = { texto: 'Usuario registrado correctamente', color: 'success' }
                this.usuario = { usuario: '', nombre: '', telefono: '', email: '', rol: '', clave: '' }
                setTimeout(() => this.$router.push({ name: 'Usuarios' }), 1500)
            } catch (err) {
                console.error('Error al registrar usuario:', err)
                const msg = err.response && err.response.data && err.response.data.mensaje
                this.mostrarMensaje = true
                this.mensaje = { texto: msg || 'Error al registrar usuario', color: 'error' }
            } finally {
                this.cargando = false
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Usuarios/NuevoUsuario.vue